// extracted by mini-css-extract-plugin
export var caretAnchor = "_v7-0";
export var dropdownContent = "_v7-1";